import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './services/authorization/auth.guard';
import { LayoutComponent } from './components/layout/layout.component';
import { NoAuthGuard } from './services/authorization/no-auth.guard';
import { SignInComponent } from './pages/sign-in/sign-in.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'example',
        loadChildren: () =>
          import('./pages/example/example.module').then((m) => m.ExampleModule),
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
      },
      {
        path: 'export-document',
        loadChildren: () =>
          import('./pages/export-document/export-document.module').then(
            (m) => m.ExportDocumentModule
          ),
        // canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
      },
      {
        path: 'master',
        loadChildren: () =>
          import('./pages/master/master.module').then((m) => m.MasterModule),
        // canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
      },
    ],
  },
  {
    path: 'sign-in',
    component: SignInComponent,
    canActivate: [NoAuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
